(function() { module.exports = this["wc"]["wcBlocksRegistry"]; }());